import axios from 'axios'
import { accessType } from '../interfaces/ProgressSettings'

const API_URL = process.env.REACT_APP_API_URL

const ROLE = `${API_URL}role/`
const ROLES = `${API_URL}roles/`
const ACCESS_ROLE_LEAD = `${API_URL}role-lead-template-accesses/`
const ACCESS_ROLE_MEETING = `${API_URL}role-meeting-template-accesses/`
const ACCESS_ROLE_MERCHANT = `${API_URL}role-merchant-template-accesses/`
const ACCESS_ROLE_REIMBURSEMENT = `${API_URL}role-reimbursement-template-accesses/`

export const insertRole = async (
  token: string,
  name: string,
  has_subordinate: boolean,
  maxDiscountNominal: number | null,
  maxDiscountPercentage: number | null,
  permission_pipeline_create: string,
  permission_pipeline_read: string,
  permission_pipeline_update: string,
  permission_pipeline_delete: string,
  permission_meeting_create: string,
  permission_meeting_read: string,
  permission_meeting_update: string,
  permission_meeting_delete: string,
  permission_merchant_create: string,
  permission_merchant_read: string,
  permission_merchant_update: string,
  permission_merchant_delete: string,
  permission_product_create: string,
  permission_product_read: string,
  permission_product_update: string,
  permission_product_delete: string,
  permission_reimbursement_create: string,
  permission_reimbursement_read: string,
  permission_reimbursement_update: string,
  permission_reimbursement_delete: string,
  permission_pipeline_log_create: string,
  permission_user_target_set: string,
  is_allowed_export_excel: boolean,
  is_allowed_send_report: boolean,
  is_allowed_access_hpp: boolean,
  is_allowed_set_analytic: boolean,
  canReadAttendanceReport: boolean,
  canApproveAttendance: boolean,
  canApproveReimbursement: boolean,
  canUploadReimbursementProofOfPayment: boolean,
  lead_progress_accesses: {
    leadProgressIds: string[],
    accessType: accessType
  },
  lead_template_ids: string[],
  merchant_template_ids: string[],
  meeting_template_ids: string[],
  reimbursement_template_ids: string[]
) => {
  return axios.post(
    ROLE,
    {
      name,
      has_subordinate,
      maxDiscountNominal,
      maxDiscountPercentage,
      permission_pipeline_create,
      permission_pipeline_read,
      permission_pipeline_update,
      permission_pipeline_delete,
      permission_meeting_create,
      permission_meeting_read,
      permission_meeting_update,
      permission_meeting_delete,
      permission_merchant_create,
      permission_merchant_read,
      permission_merchant_update,
      permission_merchant_delete,
      permission_product_create,
      permission_product_read,
      permission_product_update,
      permission_product_delete,
      permission_reimbursement_create,
      permission_reimbursement_read,
      permission_reimbursement_update,
      permission_reimbursement_delete,
      permission_pipeline_log_create,
      permission_user_target_set,
      is_allowed_export_excel,
      is_allowed_send_report,
      is_allowed_access_hpp,
      is_allowed_set_analytic,
      canReadAttendanceReport,
      canApproveAttendance,
      canApproveReimbursement,
      canUploadReimbursementProofOfPayment,
      lead_progress_accesses: lead_progress_accesses,
      lead_template_ids: lead_template_ids,
      merchant_template_ids: merchant_template_ids,
      meeting_template_ids: meeting_template_ids,
      reimbursement_template_ids: reimbursement_template_ids
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const updateRole = async (
  token: string,
  id: string,
  name: string,
  has_subordinate: boolean,
  maxDiscountNominal: number | null,
  maxDiscountPercentage: number | null,
  permission_pipeline_create: string,
  permission_pipeline_read: string,
  permission_pipeline_update: string,
  permission_pipeline_delete: string,
  permission_meeting_create: string,
  permission_meeting_read: string,
  permission_meeting_update: string,
  permission_meeting_delete: string,
  permission_merchant_create: string,
  permission_merchant_read: string,
  permission_merchant_update: string,
  permission_merchant_delete: string,
  permission_pipeline_log_create: string,
  permission_pipeline_log_read: string,
  permission_pipeline_log_update: string,
  permission_pipeline_log_delete: string,
  permission_pipeline_progress_create: string,
  permission_pipeline_progress_read: string,
  permission_pipeline_progress_update: string,
  permission_pipeline_progress_delete: string,
  permission_pipeline_source_create: string,
  permission_pipeline_source_read: string,
  permission_pipeline_source_update: string,
  permission_pipeline_source_delete: string,
  permission_product_create: string,
  permission_product_read: string,
  permission_product_update: string,
  permission_product_delete: string,
  permission_reimbursement_create: string,
  permission_reimbursement_read: string,
  permission_reimbursement_update: string,
  permission_reimbursement_delete: string,
  permission_user_create: string,
  permission_user_read: string,
  permission_user_update: string,
  permission_user_delete: string,
  permission_user_target_set: string,
  is_allowed_export_excel: boolean,
  is_allowed_send_report: boolean,
  is_allowed_access_hpp: boolean,
  is_allowed_set_analytic: boolean,
  canReadAttendanceReport: boolean,
  canApproveAttendance: boolean,
  canApproveReimbursement: boolean,
  canUploadReimbursementProofOfPayment: boolean,
  lead_template_ids: string[],
  merchant_template_ids: string[],
  meeting_template_ids: string[],
  reimbursement_template_ids: string[]
) => {
  return axios.patch(
    ROLE + id,
    {
      name,
      has_subordinate,
      maxDiscountNominal,
      maxDiscountPercentage,
      permission_pipeline_create,
      permission_pipeline_read,
      permission_pipeline_update,
      permission_pipeline_delete,
      permission_meeting_create,
      permission_meeting_read,
      permission_meeting_update,
      permission_meeting_delete,
      permission_merchant_create,
      permission_merchant_read,
      permission_merchant_update,
      permission_merchant_delete,
      permission_pipeline_log_create,
      permission_pipeline_log_read,
      permission_pipeline_log_update,
      permission_pipeline_log_delete,
      permission_pipeline_progress_create,
      permission_pipeline_progress_read,
      permission_pipeline_progress_update,
      permission_pipeline_progress_delete,
      permission_pipeline_source_create,
      permission_pipeline_source_read,
      permission_pipeline_source_update,
      permission_pipeline_source_delete,
      permission_product_create,
      permission_product_read,
      permission_product_update,
      permission_product_delete,
      permission_reimbursement_create,
      permission_reimbursement_read,
      permission_reimbursement_update,
      permission_reimbursement_delete,
      permission_user_create,
      permission_user_read,
      permission_user_update,
      permission_user_delete,
      permission_user_target_set,
      is_allowed_export_excel,
      is_allowed_send_report,
      is_allowed_access_hpp,
      is_allowed_set_analytic,
      canReadAttendanceReport,
      canApproveAttendance,
      canApproveReimbursement,
      canUploadReimbursementProofOfPayment,
      // lead_progress_accesses: lead_progress_accesses,
      lead_template_ids: lead_template_ids,
      merchant_template_ids: merchant_template_ids,
      meeting_template_ids: meeting_template_ids,
      reimbursement_template_ids: reimbursement_template_ids
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const deleteRole = async (id: string, token: string) => {
  return axios.delete(ROLE + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const getAccessRolePipeline = async (id: string, token: string) => {
  return axios.get(ACCESS_ROLE_LEAD + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const setAccessRolePipeline = (leadTemplateIds: string[], idRole: string, token: string) => {
  return axios.patch(
    ACCESS_ROLE_LEAD + idRole,
    {
      leadTemplateIds,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const getAccessRoleMeeting = async (id: string, token: string) => {
  return axios.get(ACCESS_ROLE_MEETING + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const setAccessRoleMeeting = (meetingTemplateIds: string[], idRole: string, token: string) => {
  return axios.patch(
    ACCESS_ROLE_MEETING + idRole,
    {
      meetingTemplateIds,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const getAccessRoleMerchant = async (id: string, token: string) => {
  return axios.get(ACCESS_ROLE_MERCHANT + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const setAccessRoleMerchant = (merchantTemplateIds:string[], idRole: string, token: string) => {
  return axios.patch(
    ACCESS_ROLE_MERCHANT + idRole,
    {
      merchantTemplateIds,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  )
}

export const getAccessRoleReimbursement = async (id: string, token: string) => {
  return axios.get(ACCESS_ROLE_REIMBURSEMENT + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}

export const setAccessRoleReimbursement = (reimbursementTemplateIds: string[], idRole: string, token: string) => {
  return axios.patch(
    ACCESS_ROLE_REIMBURSEMENT + idRole,
    {
      reimbursementTemplateIds,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
    )
}

export const getDetailRole = async (id: string, token: string) => {
  return axios.get(ROLES + id, {
    headers: {
      'X-Auth-token': token,
    },
  })
}